<template>
  <div class="otherWrap">
    <!-- 热门排行 -->
    <div class="TopRanking borderSty">
      <h3>热门排行</h3>
      <ul>
        <li v-for="(item, index) in TopRankingList" :key="index">
          <router-link
            :to="{ path: '/bookDetail', query: { InformationId: item.id } }"
            target="_blank"
          >
            <p :title="item.title">{{ item.title }}</p>
            <span>{{ item.personTimes + "人购买" }}</span>
          </router-link>
        </li>
      </ul>
    </div>
		<!-- 隧说网事 -->
		<!-- <div class="ssws-box">
			<h3>情报专辑</h3>
			<router-link to="/tunnelOnline" class="img-box">
				<img src="../assets/img/ssws_banner.png" />
			</router-link>
		</div> -->
    <!-- 更多资料 -->
    <!--		<div class="MoreInfor borderSty">-->
    <!--			<h3>更多资料</h3>-->
    <!--			<ul>-->
    <!--				<li v-for="(item,index) in MoreInforList" :key="index">-->
    <!--					<router-link :to="{path:'/bookDetail', query:{InformationId:item.id}}" :title="item.title" target="_blank">-->
    <!--						<img :src="item.imagePath" alt="" :onerror="defaultImg" />-->
    <!--						<p>{{item.title}}</p>-->
    <!--					</router-link>-->
    <!--				</li>-->
    <!--			</ul>-->
    <!--		</div>-->
    <!--  深邃合集  -->
    <!-- <div class="MoreInfor borderSty">
           <router-link :to="{ path: '/deepCompDetail', query: { informationCategoryId: 1 } }" tag="a" target="_blank" ><img src="../assets/img/adv-banner.png"/></router-link>
    </div> -->
    <!-- 栏目介绍 -->
    <div class="ColumnIntr borderSty">
      <h3>栏目介绍</h3>
      <p class="intrText">
        知识服务平台是隧道网打造的电子资料服务栏目，基于长期沉淀的丰富的施工经验和大量国际前沿技术工法，旨在为广大网友提供更多有价值的信息和技术资料。如有其他需求请与编辑联系。
      </p>
      <p>在线时间：周一至周五, 9:00-16:00</p>
      <p>客服QQ：3235393303</p>
      <p>客服电话：021-64225589</p>
    </div>
    <!-- 广告 -->
    <!-- <div class="ad-banner-img">
      <router-link to="/bookDetail/bookCatalog?InformationId=162">
        <img src="../assets/img/index_banner.jpg" />
      </router-link>
    </div> -->
    <!-- 手机订阅 -->
    <div class="MobileSub borderSty">
      <h3>手机订阅</h3>
      <div><img src="../assets/img/QRcode.png" alt="" /></div>
    </div>
    <!-- 隧说网事 -->
    <div class="TunnelTalkOnline borderSty">
      <h3>隧说网事</h3>
      <router-link to="/bookDetail/bookCatalog?InformationId=162" class="banner-img">
        <img src="../assets/img/index_banner.jpg" />
      </router-link>
      <div class="tunnel-online_list">
        <a
          v-for="(item,index) in MoreInforList"
          :key="index"
          :href="item.url"
          target="_blank"
          class="tunnel-online_item"
        >
          <img :src="item.imagePath" alt="" :onerror="defaultImg" />
          <div class="tunnel-online_item_text">
            {{ item.title }}
          </div>
        </a>
      </div>
    </div>
    <!-- 相关专题 -->
    <div class="about-topic borderSty">
      <div class="topic-title">相关专题</div>
      <div class="topic-item">
        <a
          class="item-fkw"
          href="https://www.tunnelling.cn/PSpecial/MethodSpecial.aspx?specialId=130"
          target="_blank"
        >
          非开挖技术专题
        </a>
        <a
          class="item-dtfx"
          href="https://www.tunnelling.cn/PSpecial/MetroFloodPrevention.aspx?specialId=199"
          target="_blank"
        >
          地铁防汛专题
        </a>
        <!-- <a class="item-smsdg" href="" target="_blank">双模式盾构专题</a> -->
        <!-- <a class="item-mr" href="" target="_blank">默认专题</a> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultImg: 'this.src="' + require("../assets/img/default_pic.png") + '"', // 默认封面
      TopRankingList: [], // 热门排行
      MoreInforList: [
        {
          title: "2020年",
          url: Tunnel_Api_Root + "/PLibrary/PLibraryCorpusDetail.aspx?Book=169",
          imagePath: require("../assets/img/2020.png")
        },
        {
          title: "2019年",
          url: Tunnel_Api_Root + "/PLibrary/PLibraryCorpusDetail.aspx?Book=168",
          imagePath: require("../assets/img/2019.png")
        },
        {
          title: "2018年",
          url: Tunnel_Api_Root + "/PLibrary/PLibraryCorpusDetail.aspx?Book=171",
          imagePath: require("../assets/img/2018.png")
        },
        {
          title: "2017年",
          url: Tunnel_Api_Root + "/PLibrary/PLibraryCorpusDetail.aspx?Book=167",
          imagePath: require("../assets/img/2017.png")
        }
      ] // 隧说网事资料
    };
  },
  mounted() {
    // 获取热门排行
    this.GetTopRanking();
    // 获取更多资料
    // this.GetMoreInfor();
  },
  methods: {
    // 获取热门排行
    GetTopRanking() {
      let api = "/api/information/hot?PageNumber=1&PageSize=3&OrderByDictionary[PersonTimes]=desc&OrderByDictionary[CreationDate]=desc";
      this.$fetch(api)
        .then(res => {
          this.TopRankingList = res.data;
        })
        .catch(err => {
          throw err;
        });
    },
    // 获取更多资料(同热门推荐)
    GetMoreInfor() {
      let params = "?PageNumber=1&PageSize=4&IsRecommend=true&OrderByDictionary[DisplayIndex]=desc&OrderByDictionary[CreationDate]=desc";
      this.$fetch("/api/information" + params)
        .then(res => {
          this.MoreInforList = res.data;
        })
        .catch(err => {
          throw err;
        });
    }
  }
};
</script>

<style scoped>
	@import './DetailOther.css';
</style>



// WEBPACK FOOTER //
// src/components/DetailOther.vue